export function getUrlParams(url) {
  const reg = /(\w+)=([^&]+)/g
  const params = {}
  let match

  while ((match = reg.exec(url)) !== null) {
    params[match[1]] = match[2]
  }

  return params
}
//特殊字符
export function specCharPattern(specChar) {
  let pattern = /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/
  let result = pattern.test(specChar)
  return result
}
